export const AppMap = () => import('../../../../components/AppMap.vue' /* webpackChunkName: "components/app-map" */).then(c => wrapFunctional(c.default || c))
export const AppSlideCarousel = () => import('../../../../components/AppSlideCarousel.vue' /* webpackChunkName: "components/app-slide-carousel" */).then(c => wrapFunctional(c.default || c))
export const AppVideo = () => import('../../../../components/AppVideo.vue' /* webpackChunkName: "components/app-video" */).then(c => wrapFunctional(c.default || c))
export const FooterAppFooter = () => import('../../../../components/footer/AppFooter.vue' /* webpackChunkName: "components/footer-app-footer" */).then(c => wrapFunctional(c.default || c))
export const FooterAppFooterMobileActive = () => import('../../../../components/footer/AppFooterMobileActive.vue' /* webpackChunkName: "components/footer-app-footer-mobile-active" */).then(c => wrapFunctional(c.default || c))
export const FooterAppFooterMobileButton = () => import('../../../../components/footer/AppFooterMobileButton.vue' /* webpackChunkName: "components/footer-app-footer-mobile-button" */).then(c => wrapFunctional(c.default || c))
export const FooterAppFooterMobileSticky = () => import('../../../../components/footer/AppFooterMobileSticky.vue' /* webpackChunkName: "components/footer-app-footer-mobile-sticky" */).then(c => wrapFunctional(c.default || c))
export const HeaderAppHeaderDesktop = () => import('../../../../components/header/AppHeaderDesktop.vue' /* webpackChunkName: "components/header-app-header-desktop" */).then(c => wrapFunctional(c.default || c))
export const HeaderAppHeaderMobile = () => import('../../../../components/header/AppHeaderMobile.vue' /* webpackChunkName: "components/header-app-header-mobile" */).then(c => wrapFunctional(c.default || c))
export const OfferedServicesAppActiveCard = () => import('../../../../components/offered-services/AppActiveCard.vue' /* webpackChunkName: "components/offered-services-app-active-card" */).then(c => wrapFunctional(c.default || c))
export const OfferedServicesAppServiceCard = () => import('../../../../components/offered-services/AppServiceCard.vue' /* webpackChunkName: "components/offered-services-app-service-card" */).then(c => wrapFunctional(c.default || c))
export const OfferedServicesAppServiceCards = () => import('../../../../components/offered-services/AppServiceCards.vue' /* webpackChunkName: "components/offered-services-app-service-cards" */).then(c => wrapFunctional(c.default || c))
export const SocialAppSocialBar = () => import('../../../../components/social/AppSocialBar.vue' /* webpackChunkName: "components/social-app-social-bar" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
